import SubmitLoLExamButton from './SubmitLoLExamButton';

export default SubmitLoLExamButton;
